import {Component} from 'react'
import {Route, BrowserRouter, Routes} from 'react-router-dom'
import Project from './Component/Project'
import About from './Component/About'
import Home from './Component/Home'
import './App.css'

class App extends Component {
  render() {
    return (
      <BrowserRouter>
        <Routes>
          <Route exact path="/" Component={Home} />
          <Route exact path="/projects" Component={Project} />
          <Route exact path="/about" Component={About} />
        </Routes>
      </BrowserRouter>
    )
  }
}

export default App
